import { render, staticRenderFns } from "./ExpenseDetails_Details.vue?vue&type=template&id=64467bc7&"
import script from "./ExpenseDetails_Details.vue?vue&type=script&lang=js&"
export * from "./ExpenseDetails_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports